module.exports = __webpack_public_path__ + "img/c28ebfb.jpg";